export default {
  10001: '사용자 이름이나 이메일을 입력하세요',
  10002: '이메일을 잘못 입력했습니다',
  10003: '사용자 이름 입력 오류',
  10004: '비밀번호를 잘못 입력했습니다',
  10005: '비정상적인 사용자 상태',
  10006: '사용자 이름이 이미 존재합니다',
  10007: '이메일이 이미 존재합니다',
  10008: '사용자 상태가 잘못되었습니다.',
  10009: '해당 사용자를 찾을 수 없습니다.',
  10010: 'Expert Advisor 제품이 잘못되었습니다.',
  10011: '이용자의 잔액이 부족한 경우에는 충전 전, 예치금을 해제하신 후 구매하시기 바랍니다.',
  10012: '해당 날짜를 찾을 수 없습니다.',
  10013: '투자 금액이 잘못되었습니다.',
  10014: '정량 결제 상품이 올바르지 않습니다',
  10015: '현재 거래가 불가능합니다',
  10016: '잘못된 구매 금액',
  10017: '해당 기간을 찾을 수 없습니다.',
  10018: '시스템 매개변수를 가져오지 못했습니다.',
  10019: '이 사용자의 현재 인증 상태가 올바르지 않습니다.',
  10020: '수집 상태가 올바르지 않습니다.',
  10021: '수신 주소가 작성되지 않았습니다.',
  10022: '사용자가 인증되지 않았습니다.',
  10023: '대출 기간이 잘못 설정되었습니다.',
  10024: '이미 동일한 상품을 구매하셨으니, 재구매는 삼가해주세요',
  10025: '출금방법을 선택해주세요',
  10027: '대출 금액은 비워둘 수 없습니다',
  10028: '대출 기간은 비워둘 수 없습니다',
  10029: '대출 금액은 0보다 커야 합니다',
  10030: '대출 기간 설정이 존재하지 않습니다',
  10031: '대출 금액이 최소값보다 작습니다',
  10032: '대출 금액이 최대값을 초과했습니다',
  10033: '대출 기록 ID는 비워둘 수 없습니다',
  10034: '대출 기록이 존재하지 않습니다',
  10035: '이 대출 기록을 조작할 권한이 없습니다',
  10036: '대출 상태가 상환을 허용하지 않습니다',
  10037: '계좌 잔액이 부족합니다',
  10094: 'VIP 등급이 부족합니다. {level} 이상 등급이 필요합니다',
  10095: '투자 금액이 최대 한도를 초과했습니다',
  10108: '미국 주식 거래 시간이 아닙니다(동부 시간 월~금 9:30-16:00). 나중에 다시 시도해 주세요',
  10109:
    '외환/귀금속 거래 시간이 아닙니다(동부 시간 일요일 17:00~금요일 17:00). 나중에 다시 시도해 주세요',
  10110: '거래 수량이 유효하지 않습니다. 0보다 큰 수량을 입력해 주세요',
  20001: '검토를 위한 제출이 완료되었습니다.',
  20002: '충전이 성공적으로 추가되었으며 검토를 위해 제출되었습니다.',
  20003: '출금이 성공적으로 추가되었으며 검토를 위해 제출되었습니다.',
  20004: '구매 성공',
  20005: '수정되었습니다.',
  20024: '이미 동일한 상품을 구매하셨으니, 재구매는 삼가해주세요',
  20094: '출금 한도 초과, 1인당 하루 1회 제한',
  20095: '출금 심사 중입니다. 중복 조작하지 마세요',
  20102:
    '계정이 동결되었습니다. 거래와 출금이 일시 중단되었습니다. 문의는 고객센터로 연락해 주세요.',
  20103: '로그인 상태가 만료되었습니다. 다시 로그인해 주세요.',
  20104: '로그인되지 않았습니다. 로그인해 주세요.',
  Invite: {
    CopyLink: '링크 복사',
    FillInAccount: '온라인 양식을 작성하여 거래 계정을 엽니다',
    Fund: '자금',
    FundYourPrefer: '원하는 자금 조달 방법을 통해 계정을 자금 조달합니다',
    InviteFriends: '친구 초대',
    InviteYourFriends: '친구를 초대하세요',
    Register: '등록',
    StartTradingPlatform: '우수한 거래 플랫폼으로 거래를 시작하세요',
    Trade: '거래',
    WhenYourRewards:
      '친구와 가족을 초대하고 함께 재정 번영을 향한 여행을 떠나면서 보상을 누리세요!',
  },
  Market: {
    CreateAPlanToTrade: '거래 계획 만들기',
    ETF: 'ETF',
    ExpectedReturn: '예상 수익',
    LastPrice: '최종 가격',
    Lots: '로트',
    OpenPrice: '개시 가격',
    OrderAgain: '다시 주문',
    OrderNumber: '주문 번호',
    Price: '가격',
    Prices: '가격...',
    Sizes: '크기...',
    SpotPrice: '스팟 가격',
    StopLossPrices: '손실 제한 가격...',
    TakeProfitPrices: '이익 실현 가격...',
    WantMoreStableEarning: '더 안정적인 수익을 원하시나요?',
    WhatIsSmartTrading: '스마트 트레이딩이란?',
    available: '사용 가능',
    buy: '매수',
    buyLong: '매수/롱',
    buyLongBtn: '매수/롱',
    chart: '차트',
    checkoutSuccess: '결제 완료',
    close: '종가',
    confirm: '확인',
    contracts: '계약 수량',
    create: '만들기',
    cypto: '크립토',
    day: '일',
    down: '하락',
    estimation: '견적',
    forex: '외환',
    free: '수수료',
    frees: '수수료 없음',
    futures: '원자재',
    high: '고가',
    hour: '시간',
    investment: '투자',
    leverage: '레버리지',
    limit: '리미트',
    low: '저가',
    market: '마켓',
    min: '분',
    mon: '개월',
    name: '이름',
    notOpen: '기능이 아직 열리지 않았습니다.',
    open: '시가',
    options: '정량 결제',
    optionsTime: '정량 결제 시간',
    orderConfirm: '주문 확인',
    requiredMargin: '필요한 마진',
    return: '수익률',
    sell: '매도',
    sellShort: '공매도',
    sellShortBtn: '공매도',
    stocks: '주식',
    stopLoss: '손절',
    stopLossPrice: '손절 가격',
    takeProfit: '이익 실현',
    takeProfitPrice: '이익 실현 가격',
    time: '시간',
    up: '상승',
    volume: '거래량',
    watchlist: '관심 종목',
    week: '주',
  },
  SmartTrading: {
    InterInvestmentAmount: '투자 금액...',
    SelectATimeframe: '시간 프레임 선택',
    create: '만들기',
    createAPlan: '계획 만들기',
    dailyYield: '일일 수익',
    days: '일',
    investment: '금액',
    investmentRange: '금액 제한',
    product: '상품',
    smrtTrading: '스마트 트레이딩',
    timeframe: '시간프레임',
  },
  aboutUs: {
    about: '회사 소개',
    subtitle1: '회사 개요',
    subtitle2: '파트너',
    title: '{title} 정보',
  },
  account: {
    BTCAmount: '금액',
    LOTS: 'LOTS',
    LastDigits: '마지막 6 자릿수',
    Lots: 'Lots',
    PaymentAmount: '지불 금액',
    PleaseUploadSubmission: '암호화폐 지불 스크린샷을 업로드하고 제출 후 검증을 기다려주세요',
    Preview: '미리보기',
    SelectImage: '이미지 선택',
    Supports: '지원 포맷: JPG, JPEG2000, PNG',
    TransactionHash: '트랜잭션 해시',
    UploadProof: '증명서 업로드',
    UploadYourScreenshot: '송금 스크린샷 업로드',
    accountVerification: '계정 인증',
    address: '주소',
    allOrders: '모든 주문',
    amount: '금액',
    approved: '승인됨',
    balance: '잔액',
    buy: '매수',
    cancel: '취소',
    changeLanguage: '언어 변경',
    changePassword: '비밀번호 변경',
    close: '닫기',
    closePrice: '청산 가격',
    closeTime: '청산 시간',
    closed: '종료됨',
    contactUs: '문의하기',
    copyAddress: '주소 복사',
    copySuccess: '성공적으로 복사되었습니다',
    cycle: '주기',
    dailyRor: '일일 수익률',
    demo: '데모',
    deposit: '입금',
    depositWithdraw: '입출금',
    down: '하락',
    downloadPDF: 'PDF 다운로드',
    earlyExist: '조기 청산',
    earlyExit: '조기 종료',
    earlyExitTip:
      '거래가 조기에 중단되면, 시스템에서 원금의 {num}을 강제 청산 비용으로 자동 공제하며, 총 수익이 감소됩니다.',
    expandMore: '더 보기',
    expirationTime: '만료 시간',
    failed: '실패',
    freeMargin: '사용된 마진',
    futures: '계약',
    helpCenter: '도움말 센터(FAQ)',
    inviteFriends: '친구 초대하기',
    lastPrice: '최종 가격',
    lever: '레버리지',
    liquidatedDamages: '청산 손해배상금',
    loan: '대출',
    logOut: '로그아웃',
    logoutConfirm: '로그아웃하시겠습니까?',
    margin: '예상 이익',
    myAccount: '내 계정',
    notification: '알림',
    notifications: '알림',
    okay: '확인',
    open: '진입',
    openPrice: '진입 가격',
    openTime: '진입 시간',
    options: '정량 결제',
    optionsOrder: '정량 결제 주문',
    order: '주문',
    pips: '픽스',
    profit: '수익',
    putAway: '숨기기',
    receiveAddress: '수신 주소',
    recreatePlan: '계획 재생성',
    refund: '환불',
    refundTip: '자금이 라이브 계좌로 환불됩니다. 확인해주세요.',
    repayNow: '지금 상환',
    repayment: '대출 상환',
    repaymentAmount: '상환 금액',
    repaymentDate: '상환 일자',
    repeatOrder: '이 주문 반복',
    reviewed: '검토 예정',
    runTime: '실행 시간',
    save: '저장',
    sell: '매도',
    settings: '설정',
    smart: '스마트',
    startTime: '시작 시간',
    staticincome: '투자 수익',
    status: '상태',
    success: '성공',
    time: '시간',
    todayEarnings: '오늘의 수익',
    todayProfit: '오늘의 수익',
    totalInterest: '총 이자',
    totalProfit: '총 수익',
    totalRepayment: '총 상환',
    totalRevenue: '총 수익',
    transFees: '거래 수수료',
    transRecord: '거래 기록',
    transaction: '거래',
    type: '유형',
    up: '상승',
    withdraw: '출금',
    withdrawNow: '지금 출금하기',
  },
  bangZhuZhongXin: '지원 센터',
  biaoDian: '구두',
  board: {
    content: '최신 기술을 바탕으로 전문적인 서비스를 제공하여 모든 요구사항을 충족합니다.',
    continue: '계속',
    skip: '건너뛰기',
    title: '최고의 거래 플랫폼',
  },
  bread: {
    introduction: '소개',
  },
  chaKan: '확인하다',
  chongZhi: '충전하다',
  chongZhiJinexiaoYuZuiDiChongZhiJinE: '충전금액이 최소충전금액보다 적습니다.',
  chongZhiPingZheng: '충전 바우처',
  chongZhiShiJian: '재충전 시간',
  chongZhiShuoMing: '재충전 지침:',
  chongZhiShuoMingUsdtZuiDiChongZhiJinewei_120btcZuiDiChongZhiJinewei_0015ethZuiDiChongZhiJinewei_02:
    '입금 안내: USDT의 최소 입금액은 120, BTC의 최소 입금액은 0.015, ETH의 최소 입금액은 0.2입니다.',
  close: '닫기',
  'customerService.error':
    '고객 지원 서비스를 일시적으로 사용할 수 없습니다. 나중에 다시 시도해 주세요.',
  'customerService.close': '닫기',
  'customerService.connected': '연결됨',
  'customerService.imageAlt': '고객 지원 이미지',
  'customerService.imagePreview': '이미지 미리보기',
  'customerService.imageTooLarge': '이미지 크기는 5MB를 초과할 수 없습니다',
  'customerService.imageTypeUnsupported': 'PNG, JPEG 또는 WebP 이미지만 지원됩니다',
  'customerService.imageUnavailable': '이미지를 사용할 수 없습니다',
  'customerService.loadFailed':
    '온라인 고객 지원 서비스를 불러올 수 없습니다. 나중에 다시 시도해 주세요.',
  'customerService.loading': '로딩 중…',
  'customerService.loginRequired': '고객 지원에 문의하려면 로그인하세요',
  'customerService.openImage': '이미지 열기',
  'customerService.placeholder': '메시지를 입력하고 Enter로 전송',
  'customerService.send': '보내기',
  'customerService.sendImage': '이미지 보내기',
  'customerService.reconnecting': '다시 연결 중',
  'customerService.title': '고객 지원',
  daDuoShuWangZhanDuHuiCaiQuCuoShiBaoHuYongHuDeGeRenXinXiLiRuShiYongJiaMiJiShuLaiBaoHuMiMa:
    '대부분의 웹사이트는 암호화 기술을 사용하여 비밀번호를 보호하는 등 사용자의 개인정보를 보호하기 위한 조치를 취하고 있습니다.',
  daDuoShuWangZhanDuYunXuYongHuGengGaiTaMenDeGeRenXinXiLiRuGengGaiDianZiYouJianDiZhiHuoMiMaDanShiMouXieXinXiKeNengWuFaGengGaiLiRuYongHuMing:
    '대부분의 웹사이트에서는 사용자가 이메일 주소나 비밀번호 등 개인정보를 변경할 수 있도록 허용합니다. \n단, 사용자 이름 등 일부 정보는 변경되지 않을 수 있습니다.',
  daiKuanHou_3TianNeiWuXuZhiFuLiXi_3TianHouXuZhiFuLiXi:
    '대출을 받은 후 {num}일 이내에는 이자가 필요하지 않으며 {num}일 후에 이자가 지급됩니다.',
  daiShenHe: '검토를 보류하다',
  danShiRuGuoNinShiYongDeWangZhanHuoYingYongChengXuCunZaiAnQuanLouDongNinDeGeRenXinXiKeNengHuiBeiXieLou:
    '그러나 귀하가 사용하는 웹사이트나 애플리케이션에 보안 취약점이 있는 경우 귀하의 개인정보가 노출될 수 있습니다.',
  dangQiLiRun: '현재 기간의 이익',
  dangQianLiXi: '현재 관심',
  daoQiHuanXiHuanBen: '기한 내에 이자와 원금을 상환',
  daoQiShiJian: '만료일',
  dengLuChengGong: '성공적 로그인',
  di: '낮은',
  dianHuaHaoMa: '전화 번호:',
  dieJiaLiShuai: '오버레이 이자율:',
  el: {
    cascader: {
      loading: 'Loading',
      noData: 'No data',
      noMatch: 'No matching data',
      placeholder: 'Select',
    },
    colorpicker: {
      clear: 'Clear',
      confirm: 'OK',
    },
    datepicker: {
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      endDate: 'End Date',
      endTime: 'End Time',
      month1: 'January',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      months: {
        apr: 'Apr',
        aug: 'Aug',
        dec: 'Dec',
        feb: 'Feb',
        jan: 'Jan',
        jul: 'Jul',
        jun: 'Jun',
        mar: 'Mar',
        may: 'May',
        nov: 'Nov',
        oct: 'Oct',
        sep: 'Sep',
      },
      nextMonth: 'Next Month',
      nextYear: 'Next Year',
      now: 'Now',
      prevMonth: 'Previous Month',
      prevYear: 'Previous Year',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      today: 'Today',
      week: 'week',
      weeks: {
        fri: 'Fri',
        mon: 'Mon',
        sat: 'Sat',
        sun: 'Sun',
        thu: 'Thu',
        tue: 'Tue',
        wed: 'Wed',
      },
      year: '',
    },
    empty: {
      description: 'No Data',
    },
    image: {
      error: 'FAILED',
    },
    messagebox: {
      cancel: 'Cancel',
      confirm: 'OK',
      error: 'Illegal input',
      title: 'Message',
    },
    pageHeader: {
      title: 'Back',
    },
    pagination: {
      goto: 'Go to',
      pageClassifier: '',
      pagesize: '/page',
      total: 'Total {total}',
    },
    popconfirm: {
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
    },
    select: {
      loading: 'Loading',
      noData: 'No data',
      noMatch: 'No matching data',
      placeholder: 'Select',
    },
    table: {
      clearFilter: 'All',
      confirmFilter: 'Confirm',
      emptyText: 'No Data',
      resetFilter: 'Reset',
      sumText: 'Sum',
    },
    transfer: {
      filterPlaceholder: 'Enter keyword',
      hasCheckedFormat: '{checked}/{total} checked',
      noCheckedFormat: '{total} items',
      noData: 'No data',
      noMatch: 'No matching data',
      titles: ['List 1', 'List 2'],
    },
    tree: {
      emptyText: 'No Data',
    },
    upload: {
      continue: 'Continue',
      delete: 'Delete',
      deleteTip: 'press delete to remove',
      preview: 'Preview',
    },
  },
  gao: '높은',
  gouMai: '구입하다',
  gouMaiChengGong: '구매 성공',
  guoJiHuoBiZhangHuLianXiZaiXianZhiChiFuWuJinHangPiPei:
    '국제 통화 계정은 일치를 위해 온라인 지원 서비스에 문의합니다.',
  home: {
    Application: '애플리케이션',
    AvailableOnThe: '다음에서 이용 가능',
    CreditCard: '암호화폐 예치',
    CreditCardInfo:
      '암호화폐 예치를 사용하여 추가적인 보안 층이 보장되고 신속한 거래 처리가 가능합니다.',
    CryptocurrenciesListed: '상장된 암호화폐',
    GetStarted: '시작하기',
    NewFeaturesInOnline: '온라인의 새로운 기능',
    NewFeaturesInOnlineInfo: '완벽한 플랫폼의 멋진 기능을 알아보세요.',
    RegisteredUsers: '등록된 사용자',
    allChains: 'All Chains',
    announcementClose: '공지 닫기',
    announcementLabel: '공지',
    announcementView: '자세히 보기',
    announcementAmount: '대여 금액',
    announcementAnnualRate: '연간 수익률',
    announcementBelowMinimum: '{amount} USDT 미만',
    announcementCompoundInterest: '복리',
    announcementCurrentConfig: '현재 설정',
    announcementEarningMode: '이자 계산 방식',
    announcementRateNotice:
      '수익은 현재 플랫폼 구간 규칙에 따라 계산됩니다. 최종 금액은 자산 페이지와 정산 기록을 확인하세요.',
    announcementRatesLoading: '현재 수익 구간을 불러오는 중…',
    announcementSettlement: '일일 정산 시간',
    announcementSimpleInterest: '단리',
    announcementYieldEyebrow: '수익 안내',
    announcementYieldIntro:
      '대여 금액이 클수록 더 높은 연간 수익률이 적용됩니다. 첫 구간 미만도 참여할 수 있지만 이자는 발생하지 않습니다.',
    announcementYieldTitle: '현재 수익 상세',
    appLicationInfo: '역할 분담을 버린 모바일 뱅킹으로 재무를 관리하는 정밀한 도구를 제공합니다.',
    billion: 'B',
    billionInfo: '평균 24시간 거래량',
    button1Title: '가장 낮은 거래 수수료',
    button1Title1: '한 곳에서 모든 자산 거래',
    button1Title2: '외환, 암호화폐, 주식, 지수, 상품',
    button2Title: '낮은 이자율과 높은 금액',
    button2Title1: '가상화폐 대출',
    button2Title2: '담보 없이 가상화폐 대출 가능',
    button3Title: '간단하고 안정적인',
    button3Title1: '스마트 트레이딩',
    button3Title2: '클릭 한 번으로 수익 계획 생성',
    button4Title: '세계 어린이를 돕습니다',
    button4Title1: 'NFT 자선',
    button4Title2: 'UNICEF 지원을 위해 NFT 아트워크 구매',
    closeFeatured: 'Close featured',
    colApy: 'APY',
    colAsset: 'Asset',
    colChain: 'Chain',
    colTotalDeposits: 'Total Deposits',
    depositAction: 'Deposit',
    depositSubtitle: '대출 풀에 유동성을 제공하여 이자를 얻으세요',
    depositTitle: 'Defi Lending Pool',
    featured: 'Featured',
    filterAssets: 'Filter assets...',
    homeTitle: '350개 이상의 암호화폐를 최고의 플랫폼에서 구매, 거래, 보유하세요.',
    loading: 'Loading...',
    million: 'M',
    noMore: 'No more pools',
    noPools: 'No lending pools yet',
    noticeInfo: '지갑에서 BTC를 USD로 스왑 가능합니다.',
    noticeInfo1: '데모 계정으로 운영 가능합니다.',
    periodDays: '{count} day | {count} days',
    sortApy: 'Sort: APY',
    sortTotalDeposits: 'Sort: Total Deposits',
  },
  huanKuanZhong: '상환 진행 중',
  huanYingShiYongWoMenLvHuoShuRongDeJinRongJiaoYiPingTaiYuQuanQiuTouZiZheYiQiTanSuoWeiLaiDeJinRongShiJie:
    '수상 경력에 빛나는 금융 거래 플랫폼을 사용하고 글로벌 투자자와 함께 미래 금융 세계를 탐험해 보세요!',
  jiXiShiJian: '이자 발생 시간',
  jiXuTouZi: '계속 투자하세요',
  jiangTuPianTuoFangDaoCiChuHuo: '여기에 이미지를 드래그 앤 드롭하거나',
  jieZhiShiJian: '마감 시간',
  jiuMiMa: '기존 비밀번호',
  juJueYuanYin: '거절 사유',
  kai: '열려 있는',
  lendingAssets: {
    authorizedBalance: '승인된 잔액',
    availableAmount: '출금 가능 금액',
    dailyOrders: '일일 정산 주문',
    dailyProfit: '일일 수익',
    joinPool: '풀 참여하기',
    loadMore: '더 보기',
    needAuth: '렌딩 풀에 참여하면 잔액과 수익을 확인할 수 있습니다',
    needLogin: '자산을 보려면 로그인하세요',
    noOrders: '정산 주문이 없습니다',
    pageDesc: '승인된 잔액, 렌딩 수익 및 일일 정산 주문 확인',
    poolEarnings: '렌딩 풀 수익',
    todayEarnings: '오늘 수익',
    totalEarnings: '누적 수익',
    withdraw: '출금',
    withdrawRecords: '출금 내역',
    withdrawnAmount: '출금 완료 금액',
  },
  lendingContent: {
    rulesSecurity:
      "<p>This page describes <strong>interest accrual rules, settlement cadence, and security mechanisms</strong> for the lending pool. Please read carefully before participating.</p>\n\n<h2>1. Interest Rules</h2>\n<h3>1.1 Accrual Base</h3>\n<p>Earnings accrue on your <strong>authorized on-chain balance</strong> after Approve. Once authorized, the system reads your USDT / USDC (and other supported asset) allowance and balance as the principal reference for each settlement period.</p>\n\n<h3>1.2 Interest Rate</h3>\n<p>Settlement rates reference the associated pool's <strong>Supply APY</strong>, updated as on-chain market data syncs. APY includes base and reward components; the rate effective for each period applies at settlement time.</p>\n\n<h3>1.3 Settlement Cadence</h3>\n<ul>\n  <li><strong>Frequency:</strong> A yield settlement order is generated once daily;</li>\n  <li><strong>Order type:</strong> Period earnings (viewable under My Portfolio → Settlement Orders);</li>\n  <li><strong>Fields shown:</strong> Amount, token type (USDT / USDC), settlement time.</li>\n</ul>\n<p>Approximate daily amount ≈ Authorized balance × APY ÷ 365 (daily proration). Very small amounts may round to zero.</p>\n\n<h3>1.4 Total &amp; Today</h3>\n<p><strong>Total Earnings</strong> is the sum of historical settlements. <strong>Today</strong> reflects settlements from 00:00 to now (server time). Figures are based on system order records.</p>\n\n<h2>2. Authorization &amp; Security</h2>\n<h3>2.1 Non-Custodial</h3>\n<p>This service is <strong>non-custodial</strong>: we do not store private keys, seed phrases, or credentials that can move funds directly. All on-chain authorization requires confirmation in your wallet.</p>\n\n<h3>2.2 Authorization Scope</h3>\n<p>Joining a pool requires ERC-20 <strong>Approve</strong>, allowing the protocol contract to interact within your allowance. You should:</p>\n<ul>\n  <li>Confirm only authorization requests initiated from the official UI;</li>\n  <li>Periodically review and revoke unused approvals in your wallet;</li>\n  <li>Never approve unknown addresses or phishing sites.</li>\n</ul>\n\n<h3>2.3 Account &amp; API Security</h3>\n<ul>\n  <li>Client APIs use token authentication; sensitive actions require an active session;</li>\n  <li>Full-site HTTPS encryption;</li>\n  <li>Authorization and settlement records are retained for audit and queries.</li>\n</ul>\n\n<h2>3. On-Chain Protocol Security</h2>\n<ul>\n  <li>Underlying protocols use audited open-source smart contracts; deposit, borrow, and liquidation run on-chain;</li>\n  <li>Over-collateralization and liquidation help maintain solvency;</li>\n  <li>Pool TVL, APY, and utilization data from public sources may lag on-chain state by minutes.</li>\n</ul>\n\n<h2>4. User Responsibilities</h2>\n<ul>\n  <li>DeFi yields fluctuate; <strong>fixed returns are not guaranteed</strong>;</li>\n  <li>Stablecoins may de-peg under extreme conditions;</li>\n  <li>Network congestion may delay authorization or queries;</li>\n  <li>Never share private keys, seed phrases, or verification codes;</li>\n  <li>Stop immediately and contact support if you see suspicious links or approval prompts.</li>\n</ul>\n\n<h2>5. Revocation &amp; Exit</h2>\n<p>You may set token allowance to <strong>zero in your wallet</strong> to revoke Approve at any time. No new period earnings accrue after revocation; historical settlements remain queryable. Revocation does not change on-chain asset ownership—funds remain in your wallet address.</p>\n\n<p>— If rules change, the latest client display and settlement records prevail.</p>",
    whitepaper:
      '<p><strong>문서 버전:</strong> V3.28 &nbsp;|&nbsp; <strong>게시일:</strong> 2022 &nbsp;|&nbsp; <strong>문서 유형:</strong> 제품 백서 및 보안 평가 요약</p>\n\n<h2>1. 요약</h2>\n<p>본 렌딩 풀(Lending Pool)은 탈중앙화 금융(DeFi) 머니마켓 프로토콜 위에 구축된 온체인 유동성 대출·예치 서비스 모듈입니다. 오픈소스 스마트 계약과 프로그래밍 가능한 금리 모델을 통해 사용자의 디지털 자산을 성숙한 온체인 대출 시장에 연결하여 <strong>예치 수익, 담보 대출, 유동성 공유</strong> 등 핵심 기능을 제공합니다.</p>\n<p>본 모듈은 일상적인 자금 배분에 인위적 개입을 필요로 하지 않으며, 금리·한도·이용률 등 주요 지표는 온체인 시장에서 실시간으로 결정되고 다중 소스 데이터 집계 및 정기 동기화를 통해 투명하게 표시됩니다.</p>\n\n<h2>2. 산업 배경 및 제품 포지셔닝</h2>\n<p>전통 금융 대출은 신용 평가와 자금 중개를 중앙 기관에 의존합니다. DeFi 대출 프로토콜은 스마트 계약으로 수요와 공급을 자동 매칭하며, 과담보 및 청산 메커니즘으로 시스템 지급 능력을 보호합니다.</p>\n<p>본 렌딩 풀 모듈의 포지셔닝:</p>\n<ul>\n  <li><strong>온체인 머니마켓 게이트웨이:</strong> 다중 체인·다중 프로토콜 렌딩 풀 데이터 집계;</li>\n  <li><strong>프로그램 기반 수익 분배:</strong> 승인 잔액과 시장 APY에 따라 고정 주기로 자동 정산;</li>\n  <li><strong>투명성 및 검증 가능성:</strong> TVL, APY, 이용률, LTV는 공개 온체인 데이터로 추적 가능;</li>\n  <li><strong>비수탁 설계:</strong> 자산 승인 및 온체인 상호작용은 사용자 지갑에서 시작.</li>\n</ul>\n\n<h2>3. 시스템 아키텍처</h2>\n<h3>3.1 아키텍처 개요</h3>\n<ul>\n  <li><strong>사용자 인터페이스 계층:</strong> 지갑 연결, 승인, 풀 탐색, 수익 조회;</li>\n  <li><strong>비즈니스 서비스 계층:</strong> 인증, 승인 관리, 수익 주문 생성, 다국어 콘텐츠;</li>\n  <li><strong>데이터 집계 계층:</strong> 공개 DeFi 데이터 소스에서 정기적으로 지표 동기화;</li>\n  <li><strong>온체인 프로토콜 계층:</strong> 감사된 오픈소스 대출 프로토콜이 입출금 로직 실행.</li>\n</ul>\n\n<h3>3.2 핵심 지표</h3>\n<table>\n  <thead>\n    <tr><th>지표</th><th>설명</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>TVL</td><td>풀 내 자산의 USD 총액; 시장 깊이 반영</td></tr>\n    <tr><td>Supply APY</td><td>기본 금리와 프로토콜 보상으로 구성된 예치 연이율</td></tr>\n    <tr><td>Borrow APY</td><td>차입자가 지불하는 연간 비용</td></tr>\n    <tr><td>이용률</td><td>대출된 자금 대비 가용 자금 비율</td></tr>\n    <tr><td>Max LTV</td><td>청산 전 최대 담보 대비 대출 비율</td></tr>\n    <tr><td>Supply / Borrow Cap</td><td>집중 리스크 관리를 위한 자산별 한도</td></tr>\n    <tr><td>Available Liquidity</td><td>즉시 대출 가능한 유동성</td></tr>\n  </tbody>\n</table>\n\n<h2>4. 사용자 흐름 및 수익 메커니즘</h2>\n<ol>\n  <li><strong>지갑 연결</strong> (Web3 지갑);</li>\n  <li><strong>자산 승인</strong> (USDT, USDC 등 온체인 Approve);</li>\n  <li><strong>렌딩 풀 참여</strong>로 수익 계산 대기열 등록;</li>\n  <li><strong>수익 정산</strong>을 승인 잔액과 시장 금리 기준으로 매일 실행;</li>\n  <li><strong>자산 조회</strong>는 「내 자산」에서 잔액 및 정산 내역 확인.</li>\n</ol>\n<p><strong>과거 APY는 미래 수익을 보장하지 않습니다.</strong></p>\n\n<h3>4.3 수수료</h3>\n<h4>DeFi 수익 서비스 수수료는 어떻게 부과되나요?</h4>\n<p>온체인 거래에는 청약 및 수익 수령 등 스마트 계약 상호작용을 위해 gas 수수료가 필요합니다. 일부 자산의 경우 DeFi 렌딩 풀 및 볼트 관리자가 실제로 얻은 이익의 일정 비율을 성과 수수료로 부과할 수 있으며, 원금에는 영향을 미치지 않습니다.</p>\n\n<h2>5. 보안 설계</h2>\n<ul>\n  <li>기반 프로토콜은 감사된 오픈소스 계약 사용;</li>\n  <li>비수탁 아키텍처; 개인키·시드 구문 저장 없음;</li>\n  <li>최소한의 Token Approve 권한; 지갑에서 언제든 취소 가능;</li>\n  <li>토큰 인증, HTTPS, RBAC 관리, 운영 감사 로그.</li>\n</ul>\n\n<h2>6. 보안 평가 요약</h2>\n<table>\n  <thead>\n    <tr><th>항목</th><th>결과</th><th>비고</th></tr>\n  </thead>\n  <tbody>\n    <tr><td>스마트 계약 의존성</td><td><strong>통과</strong></td><td>공개 감사 DeFi 프로토콜</td></tr>\n    <tr><td>비수탁 및 키 관리</td><td><strong>통과</strong></td><td>개인키 저장 없음</td></tr>\n    <tr><td>API 및 인증</td><td><strong>통과</strong></td><td>토큰 인증 및 HTTPS 적용</td></tr>\n    <tr><td>데이터 동기화 및 일관성</td><td><strong>통과</strong></td><td>정기 동기화 및 스냅샷</td></tr>\n    <tr><td>수익 정산 로직</td><td><strong>통과</strong></td><td>명확한 규칙; 감사 가능한 주문</td></tr>\n  </tbody>\n</table>\n\n<h2>7. 리스크 고지</h2>\n<ul>\n  <li><strong>스마트 계약 리스크:</strong> 미발견 취약점 존재 가능;</li>\n  <li><strong>시장 리스크:</strong> APY가 크게 변동할 수 있음;</li>\n  <li><strong>청산 리스크:</strong> 담보 가격 급락 시 청산 발생 가능;</li>\n  <li><strong>스테이블코인 디페깅 리스크:</strong> USDT/USDC가 $1.00에서 이탈 가능;</li>\n  <li><strong>규제 리스크:</strong> DeFi 규제는 전 세계적으로 진화 중.</li>\n</ul>\n<p><strong>본 모듈은 투자 조언을 제공하지 않으며 고정 수익을 보장하지 않습니다.</strong></p>\n\n<h2>8. 용어집</h2>\n<ul>\n  <li><strong>APY:</strong> 연간 수익률 (Annual Percentage Yield);</li>\n  <li><strong>TVL:</strong> 총 예치 가치 (Total Value Locked);</li>\n  <li><strong>LTV:</strong> 담보 대비 대출 비율;</li>\n  <li><strong>Approve:</strong> ERC-20 토큰 승인;</li>\n  <li><strong>청산 (Liquidation):</strong> 담보 부족 시 자동 매도.</li>\n</ul>\n\n<p>— 본 문서는 정보 제공 목적이며 법률·재무·투자 조언을 구성하지 않습니다. 온체인 데이터는 블록 탐색기 및 공식 프로토콜 인터페이스에서 확인하십시오.</p>',
    yieldLadder:
      "<p><strong>Defi Lending Pool</strong> offers a transparent, tiered yield program for authorized stablecoin deposits. Your daily earnings are determined by your authorized balance (USD equivalent) and the applicable tier rate shown below. Tier rates are loaded from the platform configuration in real time.</p>\n\n<h2>1. How Yield Works</h2>\n<p>After you authorize USDT or USDC through your Web3 wallet on <strong>Defi Lending Pool</strong>, the platform uses your on-chain authorized balance as the yield base. Each calendar day, the system generates settlement orders based on the rules below (USDT and USDC are calculated and compounded separately):</p>\n<ul>\n  <li><strong>On-chain principal:</strong> Your authorized stablecoin balance at settlement time (USD equivalent);</li>\n  <li><strong>Tier rate:</strong> The daily yield rate matching your on-chain balance range in the tier table below;</li>\n  <li><strong>Compound mode (default):</strong> Daily earnings ≈ (On-chain balance + accumulated unredeemed earnings for that token) × Daily rate ÷ 100;</li>\n  <li><strong>Simple mode (if enabled):</strong> Daily earnings ≈ On-chain balance × Daily rate ÷ 100.</li>\n</ul>\n<p>Withdrawing platform earnings only affects your withdrawable balance and compound base — <strong>it does not change your on-chain wallet balance</strong>. Settlement runs <strong>4 times per day</strong>. Earnings accumulate in your account and can be viewed under <strong>Assets → Settlement Orders</strong>. Past performance does not guarantee future returns.</p>\n\n<h2>2. Yield Tier Table</h2>\n<p>The table below shows the current tier structure on <strong>Defi Lending Pool</strong>. Higher authorized balances qualify for higher indicative daily rates. Figures are <strong>daily percentages</strong>, not annualized APY.</p>\n<!-- YIELD_TIER_TABLE -->\n<p><strong>Note:</strong> Your tier is determined automatically by your <strong>on-chain authorized balance</strong> at each daily settlement. If your on-chain balance moves into a different range, the next settlement will apply the corresponding tier rate. In compound mode, accumulated unredeemed earnings participate in yield calculation but do not change tier matching.</p>\n\n<h2>3. Tier Matching Rules</h2>\n<ul>\n  <li>Only <strong>authorized (Approved)</strong> USDT / USDC balances participate in yield calculation;</li>\n  <li>Balances below the minimum tier threshold do not generate settlement orders;</li>\n  <li>Each tier applies to a closed USD balance range — the system matches the single tier that contains your balance;</li>\n  <li>Where a tier shows a rate range, settlement uses the midpoint of that range;</li>\n  <li>Tier configuration may be updated by platform operators; changes apply to future settlements only.</li>\n</ul>\n\n<h2>4. Settlement &amp; Display</h2>\n<h3>4.1 Settlement Cycle</h3>\n<ul>\n  <li><strong>Frequency:</strong> Four settlement orders per day per authorized asset;</li>\n  <li><strong>First settlement:</strong> Wallets authorized on the same day begin earning from the next calendar day;</li>\n  <li><strong>Order fields:</strong> Settlement amount, token type (USDT / USDC), applied rate, and timestamp.</li>\n</ul>\n<h3>4.2 Portfolio Metrics</h3>\n<p>On the <strong>Assets</strong> page you can track <strong>Total Earnings</strong> (historical sum) and <strong>Today's Earnings</strong> (current-day settlements). All figures are based on system order records.</p>\n\n<h2>5. Getting Started on Defi Lending Pool</h2>\n<ol>\n  <li>Log in and connect your Web3 wallet (MetaMask or compatible);</li>\n  <li>Tap <strong>Join Now</strong> in the sidebar and choose USDT or USDC;</li>\n  <li>Confirm the on-chain <strong>Approve</strong> transaction in your wallet;</li>\n  <li>Once authorized, your balance is matched to a yield tier automatically;</li>\n  <li>Check daily settlement orders and cumulative earnings on the <strong>Assets</strong> page.</li>\n</ol>\n\n<h2>6. Risk Disclosure</h2>\n<p><strong>Defi Lending Pool</strong> operates in a non-custodial model — the platform never holds your private keys. On-chain authorization carries smart-contract and market risks. Tier rates, pool capacity, and settlement outcomes may change. Please review the <strong>Rules &amp; Security</strong> page before participating.</p>\n\n<p>— Tier rates are synced from platform settings. Table values are indicative; final amounts appear in your settlement order history.</p>",
  },
  lendingDetail: {
    assetOn: 'Asset on',
    availableLiquidity: 'Available Liquidity',
    avgApy30d: '30d Avg APY',
    baseApy: 'Base APY',
    baseRates: 'Base Rates',
    borrow: 'Borrow',
    borrowDesc: 'Borrow {symbol} against your deposited collateral',
    borrowHint: 'Borrow via',
    borrowMarkets: 'Borrow Markets',
    borrowSoon: 'On-chain borrow coming soon',
    capacityFilled: 'Capacity Filled',
    chain: 'Chain',
    chains: 'Chains',
    collateral: 'Collateral',
    deposit: 'Deposit',
    depositApy: 'Deposit APY',
    depositDesc: 'Deposit {symbol} to earn yield',
    depositMarkets: 'Deposit Markets',
    depositSoon: 'On-chain deposit coming soon',
    exposure: 'Exposure',
    loading: 'Loading...',
    notEligible: 'Not eligible',
    notFound: 'Lending pool not found',
    protocol: 'Protocol',
    rewardApy: 'Reward APY',
    stablecoin: 'Stablecoin',
    stablecoinPrice: 'About $1.00',
    title: 'Pool Detail',
    totalDeposits: 'Total Deposits',
  },
  lendingIdentity: {
    needLogin: '실명 인증 전에 로그인해 주세요',
    needVerifyHint: '렌딩 풀에 참여하기 전에 실명 인증을 완료해 주세요',
    pageDesc: '실명 인증을 완료하면 렌딩 풀에 참여하여 예치 및 대출 서비스를 이용할 수 있습니다',
    pendingHint: '실명 인증이 심사 중입니다. 잠시만 기다려 주세요',
  },
  lendingMenu: {
    assets: '자산',
    chooseDepositAsset: '예치할 자산 선택',
    chooseDepositHint: '자산을 렌딩 풀에 예치하여 수익을 얻고 대출을 이용할 수 있습니다',
    copyUid: 'UID 복사',
    customerService: 'Customer Service',
    depositAssetAction: '{symbol} 예치',
    earnings: '수익 방식',
    empty: '콘텐츠가 없습니다',
    explore: '탐색',
    footerDesc:
      '오픈소스 스마트 계약을 기반으로 구축된 차세대 온체인 머니 마켓으로, 프로그래밍 규칙이 수동 통제를 대체하여 전 세계 Web3 사용자에게 안전하고 투명한 유동성 예치 및 대출 서비스를 제공합니다.',
    getStarted: '지금 참여',
    home: '홈',
    identityVerification: '실명 인증',
    intro: '소개',
    language: '언어',
    noAssetPool: '해당 자산의 렌딩 풀을 찾을 수 없습니다',
    rulesSecurity: 'Rules & Security',
    security: '보안',
    theme: '테마',
    uid: 'UID',
    whitepaper: '백서',
    yieldLadder: '수익 단계',
  },
  lendingTheme: {
    auto: '시스템',
    dark: '다크',
    light: '라이트',
    title: '테마',
  },
  lendingYieldLadder: {
    balance: '건별 대출 원금 (USDT)',
    compoundInterest: '복리',
    earningMode: '수익 표시 방식: {mode}',
    empty: '아직 단계별 금리가 설정되지 않았습니다',
    loading: '단계별 금리를 불러오는 중…',
    noteFixed: '이 단계의 고정 일일 금리로 매일 정산',
    noteRange: '구간 상한 금리로 매일 정산',
    notes: '설명',
    rate: '일일 수익률 범위',
    settlementHours: '설정된 정산 시각: {hours}',
    simpleInterest: '단리',
  },
  liangCiMiMaBuYiZhi: '두 개의 비밀번호가 일치하지 않습니다',
  loan: {
    Browse: '찾아보기',
    address: '주소:',
    birthdate: '생년월일:',
    borrow: '대출',
    borrowNow: '지금 대출 받으세요',
    borrowPlaceholder: '대출 받고 싶은 금액을 입력하세요...',
    browse: '찾아보기',
    checkIn: '제출 완료',
    confirm: '확인',
    continue: '계속',
    country: '국가:',
    dailyRate: '일일 이자율',
    days: '일',
    document: '문서:',
    done: '완료!',
    driverLicense: '운전 면허증',
    dropHere: '이곳에 이미지를 드래그하세요.',
    ensure: '확인',
    female: '여성',
    firstName: '이름:',
    idCard: '신분증',
    inHand: '손에 들고',
    lastName: '성:',
    launchCamera: '카메라 실행',
    loanAgreement: '대출 계약',
    loanAmount: '대출 금액',
    loanDetail: '대출 상세 정보',
    loanTerm: '대출 기간',
    male: '남성',
    notVerifyBtn: '인증 시작',
    notVerifyTip: '신원을 인증하고 더 많은 대출 금액을 받으세요!',
    or: '또는',
    passport: '여권',
    pendingReview: '검토 중',
    phone: '전화번호:',
    phonePlaceholder: '전화번호를 입력하세요...',
    reSign: '다시 서명',
    resubmit: '재제출',
    sex: '성별:',
    sign: '서명',
    signTip: '확인 후 서명하세요',
    signed: '서명 완료',
    startVerfication: '인증 시작',
    submit: '제출',
    supports: '지원 파일 형식: JPG, JPEG2000, PNG',
    takePhoto: '사진 촬영',
    term: '대출 기간 (일)',
    tipIdCardBack: '신분증 뒷면을 프레임 안에 놓으세요.',
    tipIdCardFront: '신분증 앞면을 프레임 안에 놓으세요.',
    tipNotPass:
      'KYC 신청이 검증되지 않았음을 알려드려 죄송합니다. 올바른 신청 자료를 다시 제출하여 KYC 검증을 완료해주시기 바랍니다. 문의사항이 있으시면 언제든지 고객 서비스팀에 문의하시기 바랍니다.',
    tipTakePhoto: '사진을 찍어주세요:',
    tipVerifiedSuccess:
      '축하합니다! KYC 신청이 검증되었으며, 이제 더 높은 수준의 서비스를 이용하실 수 있습니다.',
    tipWaitForResult:
      'KYC 문서를 제출해 주셔서 감사합니다. 저희 팀에서는 48시간 이내에 정보를 검토할 예정입니다. 결과를 기다려주시기 바랍니다.',
    title: '대출 계정',
    totalAmount: '총 이자 금액',
    verifiedSuccessfully: '성공적으로 인증되었습니다',
    verifiedUnsuccessfully: '인증 실패',
    verifyBtn: '성공적으로 인증되었습니다',
    verifyTip: '당신의 투자를 안전하게 보호하고 즉시 자금을 받으세요!',
  },
  login: {
    btnContinueFacebook: '페이스북 계정으로 계속하기',
    btnContinueGoogle: '구글 계정으로 계속하기',
    btnLogin: '로그인',
    btnLoginFacebook: '페이스북 계정으로 로그인',
    btnLoginGoogle: '구글 계정으로 로그인',
    btnNext: '다음',
    btnRecovery: '복구',
    btnRecoveryPsd: '비밀번호 복구',
    btnRegister: '가입하기',
    btnRegisterFacebook: '페이스북 계정으로 가입',
    btnRegisterGoogle: '구글 계정으로 가입',
    btnSend: '보내다',
    btnSignup: '이메일로 가입하기',
    email: '이메일',
    emailPlaceholder: '이메일 입력 (예: name@example.com)',
    emailTips: '이 이메일은 이미 등록되어 있습니다',
    hasAccount: '계정이 이미 있으신가요?',
    hasNotAccount: '계정이 없으신가요?',
    inputCode: '인증 코드를 입력하세요',
    inputEmail: '이메일을 입력하세요',
    inputPassword: '비밀번호를 입력하세요',
    inputPhone: '이메일을 입력하세요',
    inputUsernameOrEmail: '사용자 이름 또는 이메일을 입력하세요',
    labelEmail: '이메일:',
    labelEmailCode: '인증 코드:',
    labelPsd: '비밀번호:',
    labelPsdNew: '새 비밀번호:',
    labelPsdRepeat: '비밀번호 확인:',
    labelUsername: '사용자 이름:',
    labelUsernameOrEmail: '사용자 이름 또는 이메일:',
    phone: '우편:',
    phoneTips: '이 이메일 주소가 등록되었습니다',
    starLogin: '로그인으로 시작합시다!',
    starRegist: '등록으로 시작합시다!',
    starReset: '이메일로 복구합시다!',
    tipRegisterContent:
      '가입을 완료하고 흥미로운 투자 기회의 세계를 탐험하며, 금융적 성공과 성장을 위한 문턱을 뛰어넘어보세요!',
    tipRegisterTitle: '회원 가입하여 번창하는 투자 여정을 떠나보세요!',
    useEmailRegister: '이메일로 가입하기',
    usePhoneRegister: '휴대폰 번호로 가입하기',
    username: '사용자 이름',
    usernameOptional: '사용자 이름(선택, 비우면 이메일과 동일)',
    usernameTips: '이 사용자 이름은 이미 존재합니다!',
    welcome: '환영합니다',
  },
  navBottom: {
    bottomCompany: '회사',
    bottomCompanyItem1: '회사 소개',
    bottomCompanyItem2: '라이센스 감독',
    bottomCompanyItem3: '도움말 센터',
    bottomCompanyItem4: '온라인 지원',
    bottomOther: '문서',
    bottomOtherItem1: '법적 정보',
    bottomOtherItem2: '면책 조항',
    bottomOtherItem3: '위험 경고',
    bottomOtherItem4: '쿠키 정책',
    bottomOtherItem5: '광고에 대해',
    bottomPolicy: '정책',
    bottomPolicyItem1: '약관',
    bottomPolicyItem2: '개인정보 보호정책',
    bottomProduct: '제품',
    bottomProductItem1: '마켓',
    bottomProductItem2: '투자 및 대출',
    bottomProductItem3: 'NFT 자선',
    bottomProductItem4: '스마트 트레이딩',
  },
  navTab: {
    btnLogin: '로그인',
    btnSignup: '회원 가입',
    language: '언어',
    languageTips: '언어와 지역 선택',
    tabMenu1: '홈',
    tabMenu2: '마켓',
    tabMenu3: '스마트 트레이딩',
    tabMenu4: '대출',
    tabMenu5: 'NFT',
    tabMenu6: '계정',
  },
  ninShuRuDeZhiSunJiaGeBuHeLi: '입력하신 손절매 가격이 부당합니다.',
  ninShuRuDeZhiYingJiaGeBuHeLi: '입력한 이익 실현 가격이 불합리합니다.',
  notifications: {
    deposit: {
      content:
        '존경하는 사용자님, \u0024{amount}USD의 입금을 받았으며 계정 잔액에 \u0024{amount}를 성공적으로 추가했습니다.',
      title: '입금 알림',
    },
    kyc: {
      content:
        '존경하는 사용자님, KYC 인증을 통과하셨습니다. KYC 프로세스를 완료하셨으며 더 높은 수준의 서비스를 이용하실 수 있습니다.',
      title: 'KYC 인증 통과',
    },
    loan: {
      content:
        '존경하는 고객님, 축하드립니다. \u0024{amount}USD의 대출 신청이 승인되었습니다. 신청을 검토하고 승인했으며, 대출 금액이 계정에 입금되었습니다. 계정에 로그인하여 자세한 내용을 확인해 주세요.',
      title: '대출 승인',
    },
    repayment: {
      content:
        '존경하는 사용자님, \u0024{amount}USD의 상환을 성공적으로 받았습니다. 지속적인 지원에 감사드립니다.',
      title: '상환 성공',
    },
    withdraw: {
      content:
        '존경하는 사용자님, \u0024{amount} 출금 신청이 성공적으로 처리되었습니다. 관련 정보에 주의하시고 시기적절하게 확인해 주세요.',
      failed: {
        content:
          '존경하는 사용자님, \u0024{amount}의 출금 요청이 실패했습니다. 출금 세부사항을 주의 깊게 확인하시고 온라인 지원팀에 즉시 연락해 주세요.',
        title: '출금 알림',
      },
      title: '출금 알림',
    },
  },
  ntfs: {
    Address: '주소',
    AllMoneyCharities: 'NFTs 판매 대금의 모든 금액은 UNICEF 자선단체에 기부됩니다',
    BuyNFT: 'NFT 예술작품을 구매하고 세상 어린이들을 돕습니다!',
    BuyNow: '지금 구매하기',
    Chain: '체인',
    Confirm: '확인',
    Creator: '제작자',
    CumulativeDonation: '누적 기부금',
    CurrentBid: '현재 입찰가',
    Markets: '마켓',
    MyNFTs: '내 NFTs',
    NFTs: 'NFTs',
    NFTsDetail: 'NFTs 상세정보',
    PlaceABid: '입찰하기',
    RemainingTime: '남은 시간',
    Successful: '성공',
    ThanksDonation: '기부에 감사드립니다',
    Thisaddress: '이 항목은 당신의 지갑 주소로 전송됩니다',
    Verified: '인증됨',
    andUNICEF: '그리고 기부금은 UNICEF에 기부됩니다',
    charity: '자선',
  },
  null: '알 수 없는 실수',
  qingQieHuanWeiZhenShiZhangHuCaoZuo: '실계좌 운영으로 전환해주세요',
  qingShangChuanPingZheng: '인증서를 업로드해주세요.',
  qingShuRuDiZhi: '주소를 입력해주세요',
  qingShuRuShouJiHao: '이메일을 입력해주세요',
  qingShuRuTouZiJinE: '투자금액을 입력해주세요',
  qingShuRuYanZhengMa: '인증번호를 입력해주세요',
  qingShuRuZhengQueDeJinE: '정확한 금액을 입력해주세요',
  qingShuRuZhengQueDeYouXiang: '유효한 이메일을 입력해주세요',
  qingShuRuZhiSunJiaGe: '손실정지가격을 입력해주세요',
  qingShuRuZhiYingJiaGe: '이익 실현 가격을 입력하세요.',
  qingTianXieWanZhengXinXi: '전체 정보를 입력해 주세요.',
  qingZaiCiShuRuMiMa: '비밀번호를 다시 입력해주세요',
  queRenMiMa: '비밀번호 확인',
  repaySuccess: '상환 성공',
  ri: '낮',
  riLiShuai: '일일 이자율:',
  search: {
    SearchHere: '여기에서 검색',
  },
  shangChuanShiBaiQingZhongShi: '업로드하지 못했습니다. 다시 시도해 주세요.',
  shenHeBuTongGuo: '감사가 통과되지 않았습니다.',
  shou: '받다',
  shouJiHao: '우편',
  shouXuFeiShiJiDaoZhangJinE: '수수료/실제 수령 금액',
  shouYiZhong: '소득',
  shouYiZhuangTai: '소득상태',
  shuRuNinDeDianHuaHaoMa: '전화번호를 입력하세요...',
  souSuo: '찾다...',
  tiJiaoChengGong: '성공적으로 제출되었습니다',
  tiJiaoChongZhiPingZheng: '충전 바우처 제출',
  tiKuanFangShi: '출금방법',
  tiXian: '철회하다',
  tiXianDiZhi: '출금주소',
  tiXianShiJian: '출금시간',
  tiXianXuYao_3DeShouXuFeiXuYaoWangLuoJieDianQueRenHouCaiNengRuZhangQingBuYaoJiangJiaMiHuoBiZhuanGeiMoShengRen:
    '출금에는 {rate}%의 처리 수수료가 필요하며, 이는 계정에 입금되기 전에 네트워크 노드의 확인이 필요합니다.암호화폐를 낯선 사람에게 양도하지 마십시오.',
  toast: {
    UnreasonablePriceProfitLoss: '이익 실현 및 손실 제한을 위한 불합리한 가격 설정',
    buyNumbers: '구매 수량을 입력하세요',
    copyError: '복사 오류!',
    copySuccess: '복사 완료!',
    email: '이메일을 입력하세요',
    inputAll: '데이터 입력이 완료되지 않았습니다',
    logOut: '로그아웃',
    noData: '더 이상 데이터가 없습니다',
    notAddress: '주소를 입력하세요',
    notAmount: '금액을 입력하세요',
    notEmail: '이메일 형식이 올바르지 않습니다',
    notImage: '이미지 형식이 올바르지 않습니다',
    notLoanAmount: '대출 금액을 입력하세요',
    notSigned: '서명하지 않음',
    notSmartAmount: 'Smart 금액을 입력하세요',
    notSupportMedia: '사용자 미디어에 대한 액세스가 지원되지 않습니다',
    notVerify: 'KYC 인증을 수행하세요',
    notWithdrawAmount: '출금 금액을 입력하세요',
    nothingfound: '아직 검색 결과가 없습니다!',
    password: '비밀번호를 입력하세요',
    passwordNotSame: '입력한 비밀번호가 일치하지 않습니다',
    passwordRepeat: '비밀번호를 다시 입력하세요',
    uploadImage: '필요한 이미지를 업로드하세요',
    userName: '사용자 이름을 입력하세요',
  },
  tongChangXuYaoNinDeShouJiHaoYongHuMingMiMaDengJiBenXinXiYouShiHuanXuYaoGeRenXinXiHeLianXiXinXi:
    '일반적으로 이메일, 사용자 이름, 비밀번호와 같은 기본 정보가 필요하며 경우에 따라 개인 정보 및 연락처 정보가 필요합니다.',
  touZiShiJian: '투자 시간',
  touZiZhouQi: '투자주기',
  tuPianDaXiaoBuNengChaoGuo_2mb: '이미지 크기는 2MB를 초과할 수 없습니다!',
  tuPianDaXiaoBuNengChaoGuo_5m: '이미지 크기는 50MB를 초과할 수 없습니다!',
  uploadfailed: '업로드 실패',
  usdtZuiDiChongZhiJinewei_120: '{name}의 최소 입금액은 {limit}입니다.',
  waiHuiZiDongJiaoYiLiangHuaShiYiZhongLiYongJiSuanJiChengXuHeSuanFaZiDongZhiHangJiaoYiCeLveDeFangFaGaiFangFaShiYongLiShiShuJuJiShuZhiBiaoTongJiMoXingHeQiTaFenXiGongJuLaiShiBieJiaoYiXinHaoBingZaiZhiHangJiaoYiShiZiDongZhiHangZheXieXinHaoWaiHuiZiDongJiaoYiLiangHuaKeYiBangZhuJiaoYiZheXiaoChuQingXuYingXiangJianShaoCuoWuJiaoYiTiGaoJiaoYiXiaoShuaiHeYiZhiXingDanShiZiDongWaiHuiJiaoYiLiangHuaYeCunZaiYiXieQianZaiDeFengXianHeJuXianXingLiRuZiDongJiaoYiChengXuKeNengWuFaShiYingShiChangBianHuaJiaoYiChengXuHeSuanFaDeZhiLiangHeYouXiaoXingZaiHenDaChengDuShangQuJueYuLiShiShuJuDeKeKaoXingHeYouXiaoXingCiWaiZiDongJiaoYiHuanKeNengCunZaiJiShuFengXianRuDianNaoGuZhangWangLuoZhongDuanDengYinCiZaiShiYongWaiHuiZiDongJiaoYiLiangHuaQianTouZiZheXuYaoZiXiPingGuZiJiDeJiaoYiMuBiaoFengXianChengShouNengLiHeJiShuNengLiXuanZeKeKaoDeJiaoYiPingTaiJiaoYiPingTaiHeZiDongJiaoYiChengXuZuiZhongYaoDeShiTouZiZheYingShiZhongBaoChiJinShenBingCaiQuShiDangDeFengXianGuanLiCuoShiLaiBaoHuTaMenDeTouZi:
    'Forex 자동 거래 정량화는 컴퓨터 프로그램과 알고리즘을 사용하여 거래 전략을 자동으로 실행하는 방법입니다. \n이 방법은 과거 데이터, 기술 지표, 통계 모델 및 기타 분석 도구를 사용하여 거래 신호를 식별하고 거래 실행 시 이러한 신호를 자동으로 실행합니다. \nForex 자동 거래 정량화는 거래자가 감정의 영향을 제거하고, 잘못된 거래를 줄이며, 거래 효율성과 일관성을 향상시키는 데 도움이 될 수 있습니다. \n그러나 자동화된 FX 거래 수량화에는 잠재적인 위험과 한계도 있습니다. \n예를 들어, 자동화된 거래 프로그램은 시장 변화에 적응하지 못할 수 있으며, 거래 프로그램과 알고리즘의 품질과 효율성은 과거 데이터의 신뢰성과 타당성에 크게 좌우됩니다. \n또한 자동 거래에는 컴퓨터 장애, 네트워크 중단 등의 기술적 위험이 포함될 수 있습니다. 따라서 자동 외환 거래 정량화를 사용하기 전에 투자자는 거래 목표, 위험 허용 범위 및 기술적 능력을 신중하게 평가하고 신뢰할 수 있는 거래를 선택해야 합니다. 거래 플랫폼. \n거래 플랫폼 및 자동화된 거래 프로그램. \n가장 중요한 점은 투자자가 투자를 보호하기 위해 항상 주의를 기울이고 적절한 위험 관리 조치를 취해야 한다는 것입니다.',
  wallet: {
    activate: '활성화',
    authFailed: '인증 실패',
    authSuccess: '인증 성공',
    authorized: '승인됨',
    connectFailed: '지갑 연결 실패',
    connectWallet: '지갑 연결',
    connecting: '연결 중...',
    justCanWallet: '이 사이트는 분산형 애플리케이션(Dapp)에서만 접근이 가능합니다',
    networkNotSupported: '현재 네트워크는 지원되지 않습니다. 지원되는 네트워크로 변경해 주세요',
    noWalletDetected: '지갑이 감지되지 않았습니다. MetaMask 또는 TronLink를 설치해 주세요.',
    pleaseConnectWallet: '지갑을 연결해 주세요',
    status: '지갑 상태',
    testnetDisabled: '테스트넷이 비활성화되어 있습니다. 메인넷을 사용해 주세요',
    transactionCancelled: '거래가 취소되었습니다',
    unauthorized: '승인되지 않음',
    userCancelled: '사용자가 작업을 취소했습니다',
  },
  wangLuoChaoShiQingQuDingDanLieBiaoChaKanGaiDingDan:
    '네트워크 시간이 초과되었습니다. 주문을 보려면 주문 목록으로 이동하세요.',
  weiKaiQiZhiNengJiaoYi: '지능형 거래가 활성화되지 않았습니다',
  weiRenZheng: '인증되지 않음',
  weiShiMoWoXuYaoZhuCeYiGeZhangHu: '왜 계정을 등록해야 합니까?',
  weiTongGuo: '통과하지 못함',
  woDeZhuCeXinXiHuiBeiBaoMiMa: '내 등록 정보는 비밀로 유지되나요?',
  woKeYiGengGaiWoDeZhuCeXinXiMa: '등록정보를 변경할 수 있나요?',
  woKeYiZhuCeDuoGeZhangHuMa: '여러 계정을 등록할 수 있나요?',
  xiaCiShouYiShiJian: '다음 수입 시간',
  xiaDanChengGong: '성공적으로 주문했습니다',
  xinGongNengShangXian: '새로운 기능이 온라인에 있습니다!',
  xinMiMa: '새 비밀번호',
  yanShiZhangHaoBuNengShiYongGaiGongNeng: '데모 계정은 이 기능을 사용할 수 없습니다',
  yanShiZhangHuBuNengShiYongZhiNengJiaoYi: '데모 계좌는 지능형 거래를 사용할 수 없습니다',
  yanShiZhangHuYiJinYong: '데모 계정이 비활성화되었습니다',
  yiDaoQi: '유효기간이 만료되다',
  yiFenRun: '이익이 나누어졌습니다',
  yiFenRunTianShu: '이익배분일수',
  yiHuanKuan: '상환됨',
  yiJuJue: '거부됨',
  yiQieHuanWeiXuNiZhangHu: '가상계좌로 전환했습니다',
  yiQieHuanWeiZhenShiZhangHu: '실계좌로 전환되었습니다',
  yiRenZheng: '검증됨',
  yiWanCheng: '완전한',
  yiXieWangZhanKeNengYunXuYongHuZhuCeDuoGeZhangHuDanDaDuoShuWangZhanZhiYunXuMeiGeYongHuZhuCeYiGeZhangHuRuGuoNinChangShiZhuCeDuoGeZhangHuNinDeZhangHuKeNengHuiBeiJinZhiHuoShanChu:
    '일부 웹사이트에서는 사용자가 여러 계정을 등록할 수 있도록 허용하지만 대부분의 웹사이트에서는 각 사용자가 하나의 계정만 등록하도록 허용합니다. \n여러 계정을 등록하려고 하면 계정이 차단되거나 삭제될 수 있습니다.',
  zhangFu: '증가하다',
  zhenFu: '진폭',
  zhuCeChengGong: '등록 성공',
  zhuCeZhangHuKeYiRangNinGengFangBianDiShiYongWangZhanHuoYingYongChengXuDeGongNengBingKeYiBaoHuNinDeGeRenXinXi:
    '계정을 등록하면 사이트 또는 애플리케이션의 기능을 보다 편리하게 사용할 수 있으며 개인 정보가 보호됩니다.',
  zhuCeZhangHuXuYaoShiMoXinXi: '계정을 등록하려면 어떤 정보가 필요합니까?',
  zongLiXi: '총이자',
  zuiDiJia: '최저 가격',
}
